// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-mcq-progress-step-text {
  height: 19px;
  font-size: 14px;

  letter-spacing: 0;
  color: #212121;
  opacity: 1;
}

.new-mcq-step-wrapper {
  margin-top: 32px;
  margin-right: -40px !important;
  margin-bottom: 23px;
}

.new-mcq-progress-step .ant-steps-item-title {
  font-size: 14px;
  line-height: 19px;
  color: #212121 !important;
}

.new-mcq-progress-step .ant-steps-item-content {
  width: 87% !important;
}

.new-mcq-left-align .ant-steps-item-content {
  position: absolute;
  left: 40px;
  text-align: left !important;
}

.new-mcq-right-align .ant-steps-item-content {
  position: relative;
  right: 80px;
  text-align: right !important;
}

/* @Peter THE LAYOUT ON THIS PROGRESS BAR IS REALLY BAD */
.progress-title-right-3-steps .ant-steps-item-content {
  right: 45px;
  position: relative;
  text-align: right !important;
}

.progress-title-center-3-steps .ant-steps-item-content,
.new-mcq-last-tail .ant-steps-item-content{
  position: relative;
  text-align: center !important;
  /* left: -125px; DIFFERENT FROM master */
}

.new-mcq-left-center-align .ant-steps-item-content,
.new-mcq-last-tail .ant-steps-item-content{
  position: relative;
  text-align: center !important;
  left: -66px;
}

.new-mcq-progress-step .ant-steps-item-active {
  font-weight: 500;
}

.new-mcq-progress-step > .ant-steps-item-finish .ant-steps-item-icon {
  background-color: #1890ff !important;
}

.new-mcq-progress-step > .ant-steps-item-finish .ant-steps-icon {
  color: #fff !important;
  font-weight: 500;
}

.new-mcq-progress-step > .ant-steps-item-active .ant-steps-item-icon {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 2px solid #56A8F7;
  opacity: 1;
}

.new-mcq-progress-step > .ant-steps-item-wait .ant-steps-item-icon {
  background: #EEEEEE 0% 0% no-repeat padding-box;
  opacity: 1;
}

.new-mcq-progress-step > .ant-steps-item-wait .ant-steps-icon {
  color: #EEEEEE !important;
}

.new-mcq-progress-step .ant-steps-item-wait .ant-steps-item-tail,
.new-mcq-progress-step .ant-steps-item-process .ant-steps-item-tail {
  left: 13.6px !important;
}

.new-mcq-progress-step .ant-steps-item-tail {
  padding: 3.5px 0 !important;
  top: 2.6px !important;
  max-width: 285px;
  left: 8.5px !important;
}

.new-mcq-left-center-align .ant-steps-item-wait .ant-steps-item-tail,
.new-mcq-left-center-align .ant-steps-item-process .ant-steps-item-tail {
  left: 11px
}

.new-mcq-progress-step .ant-steps-item-process.new-mcq-last-tail .ant-steps-item-tail,
.new-mcq-progress-step .ant-steps-item-wait.new-mcq-last-tail .ant-steps-item-tail {
  left: 14.2px !important;
}

.new-mcq-progress-step .ant-steps-item-icon {
  height: 23px;
  width: 23px;
  line-height: 23px;
  border-radius: 23px;
}

.new-mcq-progress-step .ant-steps-item-tail::after {
  height: 12px;
  position: relative;
  right: 6.9px;
  width: 95%
}

.new-mcq-progress-step > .ant-steps-item-wait .ant-steps-item-tail::after,
.new-mcq-progress-step > .ant-steps-item-process .ant-steps-item-tail::after {
  background: #F8F8F8 0% 0% no-repeat padding-box !important;
  border-radius: 40px;
  opacity: 1;
}

.recommended-text {
  height: 16px;
  font-size: 12px;

  letter-spacing: 0;
  color: #56A8F7;
  text-transform: uppercase;
  opacity: 1;
}

.last-step {
  position: relative;
  right: 110px;
  white-space: pre;
}

.new-mcq-step-wrapper .ant-steps-item-container {
  width: 285px;
}

@media only screen and (min-width: 1201px) and (max-width: 1245px) {
  .new-mcq-progress-step .ant-steps-item-tail::after {
    min-width: 60%
  }

  .last-step {
    right: 37px
  }

  .new-mcq-step-wrapper .ant-steps-item-container {
    width: 220px;
  }

  .new-mcq-left-center-align .ant-steps-item-content,
  .new-mcq-last-tail .ant-steps-item-content{
    left: -33px;
  }
}

@media only screen and (min-width: 1246px) and (max-width: 1285px) {
  .new-mcq-progress-step .ant-steps-item-tail::after {
    min-width: 65%
  }
  .new-mcq-left-center-align .ant-steps-item-content,
  .new-mcq-last-tail .ant-steps-item-content{
    left: -33px;
  }

  .last-step {
    right: 35px
  }

  .new-mcq-step-wrapper .ant-steps-item-container {
    width: 225px;
  }
}

@media only screen and (min-width: 1286px) and (max-width: 1327px) {
  .new-mcq-progress-step .ant-steps-item-tail::after {
    min-width: 70%
  }
  .new-mcq-left-center-align .ant-steps-item-content,
  .new-mcq-last-tail .ant-steps-item-content{
    left: -33px;
  }

  .last-step {
    right: 59px
  }

  .new-mcq-step-wrapper .ant-steps-item-container {
    width: 240px;
  }
}

@media only screen and (max-width: 1369px) and (min-width: 1328px) {
  .new-mcq-progress-step .ant-steps-item-tail::after {
    min-width: 75%;
  }
  .new-mcq-left-center-align .ant-steps-item-content,
  .new-mcq-last-tail .ant-steps-item-content{
    left: -33px;
  }

  .last-step {
    right: 75px
  }

  .new-mcq-step-wrapper .ant-steps-item-container {
    width: 255px;
  }

}

@media only screen and (min-width: 1370px) and (max-width: 1416px) {
  .new-mcq-progress-step .ant-steps-item-tail::after {
    min-width: 80%
  }
  .last-step {
    right: 85px
  }

  .new-mcq-step-wrapper .ant-steps-item-container {
    width: 270px;
  }
}

@media only screen and (min-width: 1417px) and (max-width: 1456px) {
  .new-mcq-progress-step .ant-steps-item-tail::after {
    min-width: 85%
  }
}

@media only screen and (min-width: 1457px) and (max-width: 1499px) {
  .new-mcq-progress-step .ant-steps-item-tail::after {
    min-width: 90%
  }
  .new-mcq-step-wrapper .ant-steps-item-container {
    width: 285px;
  }
}

.new-mcq-step-wrapper-for-no-programmer {
  margin-top: 32px;
  margin-bottom: 23px;
}

.new-mcq-step-wrapper-for-no-programmer .ant-steps-item-tail::after {
  height: 12px;
  margin-top: -6px;
}

.new-mcq-step-wrapper-for-no-programmer .ant-steps-item-tail {
  padding: 3.5px 5px !important;
}

.new-mcq-step-wrapper-for-no-programmer .ant-steps-item-icon {
  height: 23px;
  width: 23px;
  line-height: 23px;
  border-radius: 23px;
  margin-top: 4px;
  position: absolute;
  top: 0;
}

.new-mcq-step-wrapper-for-no-programmer .ant-steps-item-finish .ant-steps-item-icon {
  background-color: #1890ff;
}

.new-mcq-step-wrapper-for-no-programmer  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
  color: #fff !important;
}

.new-mcq-step-wrapper-for-no-programmer .ant-steps-item-content {
  margin-top: 30px !important;
}

.new-mcq-step-wrapper-for-no-programmer  .ant-steps-item-active .ant-steps-item-icon {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 2px solid #1890ff;
  opacity: 1;
}

.new-mcq-step-wrapper-for-no-programmer .ant-steps-item-wait .ant-steps-item-icon {
  background: #EEEEEE 0% 0% no-repeat padding-box;
  opacity: 1;
}

.new-mcq-step-wrapper-for-no-programmer .ant-steps-item-wait .ant-steps-item-icon .ant-steps-icon {
  color: #EEEEEE !important;
}

.new-mcq-step-wrapper-for-no-programmer .ant-steps-item-process .ant-steps-item-title {
  font-weight: bold !important;
  font-size: 14px;
  line-height: 19px;
  color: #212121 !important;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/progressBar/components/progressStepsContainer/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;;EAEf,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,4BAA4B;AAC9B;;AAEA,yDAAyD;AACzD;EACE,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;;EAEE,kBAAkB;EAClB,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;;EAEE,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,+CAA+C;EAC/C,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE;AACF;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ;AACF;;AAEA;;EAEE,0DAA0D;EAC1D,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;;EAEf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE;IACE;EACF;EACA;;IAEE,WAAW;EACb;;EAEA;IACE;EACF;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE;EACF;EACA;;IAEE,WAAW;EACb;;EAEA;IACE;EACF;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;;IAEE,WAAW;EACb;;EAEA;IACE;EACF;;EAEA;IACE,YAAY;EACd;;AAEF;;AAEA;EACE;IACE;EACF;EACA;IACE;EACF;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,+CAA+C;EAC/C,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B","sourcesContent":[".new-mcq-progress-step-text {\n  height: 19px;\n  font-size: 14px;\n\n  letter-spacing: 0;\n  color: #212121;\n  opacity: 1;\n}\n\n.new-mcq-step-wrapper {\n  margin-top: 32px;\n  margin-right: -40px !important;\n  margin-bottom: 23px;\n}\n\n.new-mcq-progress-step .ant-steps-item-title {\n  font-size: 14px;\n  line-height: 19px;\n  color: #212121 !important;\n}\n\n.new-mcq-progress-step .ant-steps-item-content {\n  width: 87% !important;\n}\n\n.new-mcq-left-align .ant-steps-item-content {\n  position: absolute;\n  left: 40px;\n  text-align: left !important;\n}\n\n.new-mcq-right-align .ant-steps-item-content {\n  position: relative;\n  right: 80px;\n  text-align: right !important;\n}\n\n/* @Peter THE LAYOUT ON THIS PROGRESS BAR IS REALLY BAD */\n.progress-title-right-3-steps .ant-steps-item-content {\n  right: 45px;\n  position: relative;\n  text-align: right !important;\n}\n\n.progress-title-center-3-steps .ant-steps-item-content,\n.new-mcq-last-tail .ant-steps-item-content{\n  position: relative;\n  text-align: center !important;\n  /* left: -125px; DIFFERENT FROM master */\n}\n\n.new-mcq-left-center-align .ant-steps-item-content,\n.new-mcq-last-tail .ant-steps-item-content{\n  position: relative;\n  text-align: center !important;\n  left: -66px;\n}\n\n.new-mcq-progress-step .ant-steps-item-active {\n  font-weight: 500;\n}\n\n.new-mcq-progress-step > .ant-steps-item-finish .ant-steps-item-icon {\n  background-color: #1890ff !important;\n}\n\n.new-mcq-progress-step > .ant-steps-item-finish .ant-steps-icon {\n  color: #fff !important;\n  font-weight: 500;\n}\n\n.new-mcq-progress-step > .ant-steps-item-active .ant-steps-item-icon {\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  border: 2px solid #56A8F7;\n  opacity: 1;\n}\n\n.new-mcq-progress-step > .ant-steps-item-wait .ant-steps-item-icon {\n  background: #EEEEEE 0% 0% no-repeat padding-box;\n  opacity: 1;\n}\n\n.new-mcq-progress-step > .ant-steps-item-wait .ant-steps-icon {\n  color: #EEEEEE !important;\n}\n\n.new-mcq-progress-step .ant-steps-item-wait .ant-steps-item-tail,\n.new-mcq-progress-step .ant-steps-item-process .ant-steps-item-tail {\n  left: 13.6px !important;\n}\n\n.new-mcq-progress-step .ant-steps-item-tail {\n  padding: 3.5px 0 !important;\n  top: 2.6px !important;\n  max-width: 285px;\n  left: 8.5px !important;\n}\n\n.new-mcq-left-center-align .ant-steps-item-wait .ant-steps-item-tail,\n.new-mcq-left-center-align .ant-steps-item-process .ant-steps-item-tail {\n  left: 11px\n}\n\n.new-mcq-progress-step .ant-steps-item-process.new-mcq-last-tail .ant-steps-item-tail,\n.new-mcq-progress-step .ant-steps-item-wait.new-mcq-last-tail .ant-steps-item-tail {\n  left: 14.2px !important;\n}\n\n.new-mcq-progress-step .ant-steps-item-icon {\n  height: 23px;\n  width: 23px;\n  line-height: 23px;\n  border-radius: 23px;\n}\n\n.new-mcq-progress-step .ant-steps-item-tail::after {\n  height: 12px;\n  position: relative;\n  right: 6.9px;\n  width: 95%\n}\n\n.new-mcq-progress-step > .ant-steps-item-wait .ant-steps-item-tail::after,\n.new-mcq-progress-step > .ant-steps-item-process .ant-steps-item-tail::after {\n  background: #F8F8F8 0% 0% no-repeat padding-box !important;\n  border-radius: 40px;\n  opacity: 1;\n}\n\n.recommended-text {\n  height: 16px;\n  font-size: 12px;\n\n  letter-spacing: 0;\n  color: #56A8F7;\n  text-transform: uppercase;\n  opacity: 1;\n}\n\n.last-step {\n  position: relative;\n  right: 110px;\n  white-space: pre;\n}\n\n.new-mcq-step-wrapper .ant-steps-item-container {\n  width: 285px;\n}\n\n@media only screen and (min-width: 1201px) and (max-width: 1245px) {\n  .new-mcq-progress-step .ant-steps-item-tail::after {\n    min-width: 60%\n  }\n\n  .last-step {\n    right: 37px\n  }\n\n  .new-mcq-step-wrapper .ant-steps-item-container {\n    width: 220px;\n  }\n\n  .new-mcq-left-center-align .ant-steps-item-content,\n  .new-mcq-last-tail .ant-steps-item-content{\n    left: -33px;\n  }\n}\n\n@media only screen and (min-width: 1246px) and (max-width: 1285px) {\n  .new-mcq-progress-step .ant-steps-item-tail::after {\n    min-width: 65%\n  }\n  .new-mcq-left-center-align .ant-steps-item-content,\n  .new-mcq-last-tail .ant-steps-item-content{\n    left: -33px;\n  }\n\n  .last-step {\n    right: 35px\n  }\n\n  .new-mcq-step-wrapper .ant-steps-item-container {\n    width: 225px;\n  }\n}\n\n@media only screen and (min-width: 1286px) and (max-width: 1327px) {\n  .new-mcq-progress-step .ant-steps-item-tail::after {\n    min-width: 70%\n  }\n  .new-mcq-left-center-align .ant-steps-item-content,\n  .new-mcq-last-tail .ant-steps-item-content{\n    left: -33px;\n  }\n\n  .last-step {\n    right: 59px\n  }\n\n  .new-mcq-step-wrapper .ant-steps-item-container {\n    width: 240px;\n  }\n}\n\n@media only screen and (max-width: 1369px) and (min-width: 1328px) {\n  .new-mcq-progress-step .ant-steps-item-tail::after {\n    min-width: 75%;\n  }\n  .new-mcq-left-center-align .ant-steps-item-content,\n  .new-mcq-last-tail .ant-steps-item-content{\n    left: -33px;\n  }\n\n  .last-step {\n    right: 75px\n  }\n\n  .new-mcq-step-wrapper .ant-steps-item-container {\n    width: 255px;\n  }\n\n}\n\n@media only screen and (min-width: 1370px) and (max-width: 1416px) {\n  .new-mcq-progress-step .ant-steps-item-tail::after {\n    min-width: 80%\n  }\n  .last-step {\n    right: 85px\n  }\n\n  .new-mcq-step-wrapper .ant-steps-item-container {\n    width: 270px;\n  }\n}\n\n@media only screen and (min-width: 1417px) and (max-width: 1456px) {\n  .new-mcq-progress-step .ant-steps-item-tail::after {\n    min-width: 85%\n  }\n}\n\n@media only screen and (min-width: 1457px) and (max-width: 1499px) {\n  .new-mcq-progress-step .ant-steps-item-tail::after {\n    min-width: 90%\n  }\n  .new-mcq-step-wrapper .ant-steps-item-container {\n    width: 285px;\n  }\n}\n\n.new-mcq-step-wrapper-for-no-programmer {\n  margin-top: 32px;\n  margin-bottom: 23px;\n}\n\n.new-mcq-step-wrapper-for-no-programmer .ant-steps-item-tail::after {\n  height: 12px;\n  margin-top: -6px;\n}\n\n.new-mcq-step-wrapper-for-no-programmer .ant-steps-item-tail {\n  padding: 3.5px 5px !important;\n}\n\n.new-mcq-step-wrapper-for-no-programmer .ant-steps-item-icon {\n  height: 23px;\n  width: 23px;\n  line-height: 23px;\n  border-radius: 23px;\n  margin-top: 4px;\n  position: absolute;\n  top: 0;\n}\n\n.new-mcq-step-wrapper-for-no-programmer .ant-steps-item-finish .ant-steps-item-icon {\n  background-color: #1890ff;\n}\n\n.new-mcq-step-wrapper-for-no-programmer  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {\n  color: #fff !important;\n}\n\n.new-mcq-step-wrapper-for-no-programmer .ant-steps-item-content {\n  margin-top: 30px !important;\n}\n\n.new-mcq-step-wrapper-for-no-programmer  .ant-steps-item-active .ant-steps-item-icon {\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  border: 2px solid #1890ff;\n  opacity: 1;\n}\n\n.new-mcq-step-wrapper-for-no-programmer .ant-steps-item-wait .ant-steps-item-icon {\n  background: #EEEEEE 0% 0% no-repeat padding-box;\n  opacity: 1;\n}\n\n.new-mcq-step-wrapper-for-no-programmer .ant-steps-item-wait .ant-steps-item-icon .ant-steps-icon {\n  color: #EEEEEE !important;\n}\n\n.new-mcq-step-wrapper-for-no-programmer .ant-steps-item-process .ant-steps-item-title {\n  font-weight: bold !important;\n  font-size: 14px;\n  line-height: 19px;\n  color: #212121 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
